module.exports = __webpack_public_path__ + "img/maison20.d0b9abdb.jpg";